import { businessApiClient } from "../businessApiClient";
import { useMutation } from "react-query";

type CreateCompanyReq = {
  name: string;
  taxCode: string;
  legalAddress: string;
  actualAddress: string;
  adminUserId: string;
  cityId: 0;
  companyEmail: string;
};

export type CreateCompanyData = {
  companyId: string;
};

const createCompany = (data: CreateCompanyReq): Promise<CreateCompanyData> =>
  businessApiClient.post("/company", data).then((resp) => resp.data);

export const useCreateCompany = (
  onSuccess?: (data: CreateCompanyData) => void,
  onError?: () => void,
) => {
  const { isLoading, mutate } = useMutation(createCompany, {
    onSuccess,
    onError,
  });

  return {
    isLoading,
    mutate,
  };
};
